<template>
  <div class="relative flex h-12">
    <sparkle-icon class="pointer-events-none absolute ml-3 h-full w-4" />
    <ui-input
      v-model.trim="val"
      light
      ai-input
      :class="'border-2 !px-10 font-medium'"
      :placeholder="placeholder"
      :aria-label="placeholder"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { debounce } from 'lodash-es'
import { UiInput } from '@klausapp/ui-kit'
import SparkleIcon from '@/assets/intelligence-sparkle.svg'
import { sanitize } from '@/utils/sanitize'

const props = withDefaults(
  defineProps<{
    modelValue: string
    small?: boolean
    dataTestid?: string
    debounceTimeout?: number
    placeholder?: string
    light?: boolean
  }>(),
  { debounceTimeout: 0 },
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const val = ref(props.modelValue || '')

const emitUpdate = debounce((val) => emit('update:modelValue', sanitize(val)), props.debounceTimeout)

watch(val, () => emitUpdate(val.value))

watch(
  () => props.modelValue,
  () => {
    return (val.value = props.modelValue)
  },
)
</script>

Hologram
